import { Box } from "@mui/material";

import SegmentedControl from "@plannel/components/ui/SegmentedControl";
import { MODAL_SECTION_LABEL_SX } from "@plannel/components/modal/BaseConfigModal";

/*
 * 계층 레벨을 **하나** 고르는 필드 — 설정 모달 본문용.
 *
 *   <HrchyLevelSegments
 *     label={t("custLevel")}          // 이미 번역된 구역 제목
 *     levels={custLevelCds}           // [{ id, name }] — 서버가 준 계층 레벨 목록
 *     value={modalCustLevelCd?.id}    // 선택된 id
 *     onChange={id => …}
 *   />
 *
 * 왜 드롭다운이 아닌가: 계층 레벨은 보통 3~7개로 적은데, 드롭다운은 펼치기 전까지
 * **무엇을 고를 수 있는지 안 보인다**. 전부 펼쳐 두면 "지금 어느 레벨인지"와
 * "선택지가 몇 개인지"가 한 번에 들어온다(Dimension Setting 의 계층 레벨 줄과 같은 인상).
 *
 * ⚠ 단일선택이므로 `TokenSelectGroup`(다중선택 알약)이 아니라 `SegmentedControl` 이다.
 *   모양은 닮았지만 성격이 다르다 — 회색 알약이 여러 개 떠 있으면 "여러 개 고를 수 있나"로 읽힌다.
 *   프로젝트 규칙: 배타선택=SegmentedControl, 복수선택=토큰/체크박스.
 *
 * ⚠ 레벨 이름·개수는 테넌트 데이터다(언어마다 길이도 다르다). 세그먼트는 폭에 맞춰 접히지만,
 *   이 필드를 쓰는 모달은 `size="lg"` 이상을 줘야 한 줄에 3~4개가 들어간다.
 *
 * value 가 비어 있으면 첫 레벨을 고른 것으로 본다 — 교체 전 `<Select>` 들이 전부 그렇게 동작했다.
 */
const HrchyLevelSegments = ({ label, levels, value, onChange, sx }) => {
  const options = (levels ?? []).map(level => ({ value: level.id, label: level.name }));
  const selected = value ?? options[0]?.value ?? "";

  // 구역 사이 여백은 호출측이 준다(둘째 필드에 sx={{ mt: 2 }}) — 인접 셀렉터로 자동화하면 emotion 클래스 생성 방식에 기대게 된다
  return (
    <Box sx={sx}>
      <Box sx={{ ...MODAL_SECTION_LABEL_SX, pb: 1 }}>{label}</Box>
      <SegmentedControl options={options} value={selected} onChange={onChange} />
    </Box>
  );
};

export default HrchyLevelSegments;
